// City page template content — copy ported from source/latest/edmonton/index.html (Site v6).
// Edmonton is verbatim; other cities substitute the city name (broker decision 2026-09-10: build all
// cities from the template, customize after). No neighbourhood names are invented for other cities.
import COPY from "./content/siteCopy.json";

export const EDMONTON_NEIGHBOURHOODS = ["Chappelle", "Downtown Edmonton", "Ellerslie", "Heritage Valley", "Clareview", "Mill Woods", "Ambleside", "Windermere", "Summerside", "Terwillegar", "Riverbend", "Londonderry", "Castle Downs", "The Meadows", "Wîhkwêntôwin", "Ice District"];
export const CITY_CODES = { edmonton: "YEG", calgary: "YYC" };

// Mirrors backend NEAREST_AREA groups so "nearby communities" are real, same-region cities.
export const REGIONS = COPY.regions;
export const regionOf = (slug) => Object.keys(REGIONS).find((k) => REGIONS[k].includes(slug)) || null;

const fill = (t, city) => t.replace(/\{C\}/g, city.name).replace(/\{a\}/g, /^[AEIOU]/.test(city.name) ? "an" : "a").replace(/\{slug\}/g, city.slug);

// Copy lives in content/siteCopy.json (shared with the backend prerender — keep both in sync via backend/fixtures/site_copy.json).
export function cityContent(city) {
  const C = city.name;
  const T = COPY.city;
  const f = (t) => fill(t, city);
  return {
    title: f(T.title),
    description: f(T.description),
    ...T.seo_overrides[city.slug],
    hero: { eyebrow: f(T.hero_eyebrow), text: f(T.hero_text) },
    help: { eyebrow: f(T.help_eyebrow), text: f(T.help_text), intents: T.help_intents.map(([n, h, p, href]) => [n, h, f(p), href]) },
    tools: { eyebrow: f(T.tools_eyebrow), text: f(T.tools_text) },
    how: { eyebrow: f(T.how_eyebrow), text: f(T.how_text) },
    strategyHeading: f(T.strategy_heading),
    strategy: f(T.strategy_text),
    reviews: f(T.reviews),
    team: T.team.map(f),
    math: { text: f(T.math_text), fine: f(T.math_fine), cta: f(T.math_cta) },
    faqs: T.faqs.map(([q, a]) => [f(q), city.slug === "edmonton" && q.startsWith("Do you help with mortgages throughout") ? T.faq_edmonton_throughout : f(a)]),
    faq_heading: f(T.faq_heading),
    final: f(T.final),
    directory: {
      word: `"hello, ${C}."`, eyebrow: `Explore ${C} mortgages`, heading: f(T.directory_heading),
      text: f(T.directory_text),
      kicker: CITY_CODES[city.slug] || "AB",
      kickerLabel: f(T.directory_places_label),
      areas: city.slug === "edmonton" ? { label: "Across Edmonton", text: "Same team, same strategy — whether you’re closing in Windermere or Clareview.", items: EDMONTON_NEIGHBOURHOODS } : null,
      serviceLabel: f(T.directory_services_label),
      services: T.services.map(([n, h]) => [f(n), f(h)]),
    },
  };
}
